import {
    resetSettingsDialogViewState,
    resetAllSettingsToDefault,
} from '../actions/resetSettingsDialogViewState';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { EditorServiceModels } from '@editor/client-rest-api';
import { ObservableMap } from 'mobx';

export const resetSettingsDialogViewStateMutator = mutator(
    resetSettingsDialogViewState,
    actionMessage => {
        const { userOptions } = getStore();
        getStore().settingsDialogViewState = {
            overriddenOptions: new ObservableMap<string, EditorServiceModels.CritiqueTypeOption>(
                userOptions.overriddenOptions
            ),
            overriddenCategories: new ObservableMap<string, boolean>(
                userOptions.overriddenCategories
            ),
            spellCheckEnabled: userOptions.spellCheckEnabled,
            grammarEnabled: userOptions.grammarEnabled,
            writingRefinementsEnabled: userOptions.writingRefinementsEnabled,
            proofingLocale: userOptions.proofingLocale,
            textPredictionEnabled: userOptions.textPredictionEnabled,
        };
    }
);

export const resetAllSettingsToDefaultMutator = mutator(
    resetAllSettingsToDefault,
    actionMessage => {
        const { settingsDialogViewState } = getStore();

        if (settingsDialogViewState) {
            settingsDialogViewState.overriddenOptions?.clear();
            settingsDialogViewState.overriddenCategories?.clear();
            settingsDialogViewState.spellCheckEnabled = true;
            settingsDialogViewState.grammarEnabled = true;
            settingsDialogViewState.textPredictionEnabled = true;
        }

        actionMessage.onResetComplete();
    }
);
